/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Form_TitleInputs */

const en_site_form_title = /** @type {(inputs: Site_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn a website into your product plan`)
};

const id_site_form_title = /** @type {(inputs: Site_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedah website jadi rencana produkmu`)
};

/**
* | output |
* | --- |
* | "Turn a website into your product plan" |
*
* @param {Site_Form_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_form_title = /** @type {((inputs?: Site_Form_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Form_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_form_title(inputs)
	return en_site_form_title(inputs)
});